import styled from '../../../styled';
const FilterWrapper = styled.div `
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0.5rem;

  > *:first-child {
    flex-grow: 1;
    min-width: 16rem;
  }
  > *:not(:last-child) {
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
  }
`;
export default FilterWrapper;
//# sourceMappingURL=FilterWrapper.js.map